import { Route, Routes } from 'react-router-dom';
import { useRouteVisibility } from '../hooks/useRouteVisibility';
import { NotFound } from '../NotFound';
import { ClinicsDashboard } from './views/ClinicsDashboard';

export const Clinics = () => {
  const { isClinicsRouteVisible } = useRouteVisibility();

  if (!isClinicsRouteVisible) {
    return <NotFound />;
  }

  return (
    <Routes>
      <Route index element={<ClinicsDashboard />} />
    </Routes>
  );
};
